import View from '@hfe/max-view';
import Button from '@hfe/max-button';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import { createElement, memo } from '@max/max';
import '../calendar.scss';
import dayjs from 'dayjs';
import { DateShortcutType } from '../types';
const isMRN = false;
const WEEKDAY_DESC = {
    0: '周日',
    1: '周一',
    2: '周二',
    3: '周三',
    4: '周四',
    5: '周五',
    6: '周六'
};
const getDayDesc = value => {
    if (value.shortcutType === DateShortcutType.today || value.shortcutType === DateShortcutType.todayBeforeDawn) {
        return '今天';
    }
    if (value.shortcutType === DateShortcutType.tommorrow) {
        return '明天';
    }
    return WEEKDAY_DESC[value.weekday];
};
const CalendarFooter = ({ viewState, onConfirm }) => {
    var _a, _b, _c;
    const startDayStr = viewState.startDay ? dayjs(viewState.startDay.shortcutType === -1 ? viewState.startDay.value + 24 * 60 * 60 * 1000 : viewState.startDay.value).format('MM月DD日') : '';
    const endDayStr = viewState.endDay ? dayjs(viewState.endDay.value).format('MM月DD日') : '';
    const startDayDesc = startDayStr ? getDayDesc(viewState.startDay) : '';
    const endDayDesc = endDayStr ? getDayDesc(viewState.endDay) : '';
    const isShowBeforeDownStart = (viewState === null || viewState === void 0 ? void 0 : viewState.isBeforeDawn) && ((_a = viewState.startDay) === null || _a === void 0 ? void 0 : _a.shortcutType) === DateShortcutType.todayBeforeDawn;
    const isShowNoonStart = (viewState === null || viewState === void 0 ? void 0 : viewState.isBeforeDawn) && ((_b = viewState.startDay) === null || _b === void 0 ? void 0 : _b.shortcutType) === DateShortcutType.today;
    const isShowNoonEnd = (viewState === null || viewState === void 0 ? void 0 : viewState.isBeforeDawn) && ((_c = viewState.endDay) === null || _c === void 0 ? void 0 : _c.shortcutType) === DateShortcutType.today;
    const confirm = () => {
        if (!viewState.intervalDayNum) {
            return;
        }
        onConfirm();
    };
    return <View className="calendar-footer-container" style={isMRN ? {
        borderTopWidth: 1,
        borderTopColor: '#e5e5e5',
        paddingBottom: '50rpx'
    } : {}}>
      <View className="calendar-footer-livedays-container">
        <View className="calendar-footer-livedays-item">
          <View className="calendar-footer-livedays-tip">
            <Image x-if={isShowBeforeDownStart} className="calendar-footer-livedays-tip-icon" source={{
        uri: 'https://p0.meituan.net/ingee/7f9dce21d894d18d5624e75a1fdea86f8012.png'
    }}/>
            <Text x-if={isShowBeforeDownStart} className="calendar-footer-livedays-tip--enforce" style={isMRN ? {
        fontSize: '24rpx',
        color: '#777777'
    } : {}}>
              凌晨
            </Text>
            <Image x-if={isShowNoonStart} className="calendar-footer-livedays-tip-icon" source={{
        uri: 'https://p0.meituan.net/ingee/c6f3de532b99b97726abf4d7f759b3f88642.png'
    }}/>
            <Text x-if={isShowNoonStart} className="calendar-footer-livedays-tip--enforce" style={isMRN ? {
        fontSize: '24rpx',
        color: '#777777'
    } : {}}>
              中午
            </Text>
            <Text style={{
        fontSize: '24rpx',
        color: '#777777'
    }}>
              入住
            </Text>
          </View>
          <Text x-if={!startDayStr} className="calendar-footer-livedays-empty">
            请选择日期
          </Text>
          <View x-else className="calendar-footer-livedays-time" style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold'
    } : {}}>
            <Text style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold',
        fontSize: 16
    } : {}}>
              {startDayStr}
            </Text>
            <Text className="calendar-footer-livedays-time-tip" style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold',
        fontSize: 16
    } : {}}>
              {startDayDesc}
            </Text>
          </View>
        </View>
        <View className="calendar-footer-livedays-split">
          <Image className="calendar-footer-livedays-split-symbol" source={{
        uri: 'https://p0.meituan.net/ingee/156fc75321529ed074587b48749dcf8f272.png'
    }}/>
        </View>
        <View className="calendar-footer-livedays-item">
          <View className="calendar-footer-livedays-tip">
            <Image x-if={isShowNoonEnd} className="calendar-footer-livedays-tip-icon" source={{
        uri: 'https://p0.meituan.net/ingee/c6f3de532b99b97726abf4d7f759b3f88642.png'
    }}/>
            <Text x-if={isShowNoonEnd} className="calendar-footer-livedays-tip--enforce" style={isMRN ? {
        fontSize: '24rpx',
        color: '#777777'
    } : {}}>
              中午
            </Text>
            <Text style={{
        fontSize: '24rpx',
        color: '#777777'
    }}>
              离店
            </Text>
          </View>
          <Text x-if={!endDayStr} className="calendar-footer-livedays-empty">
            请选择日期
          </Text>
          <View x-else className="calendar-footer-livedays-time" style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold'
    } : {}}>
            <Text style={isMRN ? {
        fontSize: 16,
        fontFamily: 'MTNewDigitalDisplay-Bold'
    } : {}}>
              {endDayStr}
            </Text>
            <Text className="calendar-footer-livedays-time-tip" style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold',
        fontSize: 16
    } : {}}>
              {endDayDesc}
            </Text>
          </View>
        </View>
      </View>
      <Button className={{
        'calendar-footer-confirm-button': true,
        'calendar-footer-confirm-button--disable': !viewState.intervalDayNum
    }} onPress={confirm}>
        <Text style={isMRN ? {
        fontFamily: 'PingFangSC-Medium',
        fontWeight: '500',
        fontSize: 16,
        color: '#fff'
    } : {}}>
          确认
          <Text className="calendar-footer-confirm-button--num" style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold',
        fontWeight: '500',
        fontSize: 16,
        color: '#fff'
    } : {}}>
            {viewState.intervalDayNum}
          </Text>
          晚
        </Text>
      </Button>
    </View>;
};
export default memo(CalendarFooter);
